import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import BasicPageFilterResults from 'features/common/ui/BasicPage/Partials/BasicPageFilterResults'

interface MapClearSearchProps {
  onClear: () => void
}

function MapsClearSearch({ onClear }: MapClearSearchProps) {
  const intl = useIntl()

  const mapsStatus = useAppSelector((state) => state.maps.myMapsStatus)
  const mapsMetadata = useAppSelector((state) => state.maps.myMapsMetadata)
  const currentSearch = useAppSelector((state) => state.maps.myMapsFilters.search)

  const [filterMessage, setFilterMessage] = useState<string>()

  useEffect(() => {
    if (mapsStatus === RequestStatus.Fulfilled && currentSearch) {
      setFilterMessage(
        intl.formatMessage(
          {
            id: 'maps.filters.title'
          },
          {
            elements: mapsMetadata?.total || 0,
            query: decodeURIComponent(currentSearch)
          }
        )
      )
    } else if (!currentSearch) {
      setFilterMessage('')
    }
  }, [intl, mapsMetadata, setFilterMessage, mapsStatus, currentSearch])

  if (!filterMessage) return null

  return <BasicPageFilterResults results={filterMessage} linkLabel="clear-maps-search" linkAction={onClear} />
}

export default MapsClearSearch
